//=====================================================================================
// #1 - Base Imports
//=====================================================================================
import React from "react";

//=====================================================================================
// #1 - Import * React Router Dom
//=====================================================================================
import { Link, useHistory } from "react-router-dom";

//=====================================================================================
// #2 - Import * Styled Components
//=====================================================================================
import { Branding } from "./styles";

export const Logo = ({ link, image, alt }) => {

    const history = useHistory();

    return (
        <>
            <Branding>
                <Link to={{pathname: link ? link : "#undefined-link", search: history.location.search}}>
                    <img src={image} alt={alt} />
                </Link>
            </Branding>
        </>
    )
}

export default Logo;